import { useContext } from "react";

import { TemplatesContext } from "../contexts/bots/TemplatesContext";

const useTemplates = () => useContext(TemplatesContext);

export default useTemplates;
